export default __webpack_public_path__ + "static/media/ cellphone.5951daed.svg";